import { AbstractDataProvider } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/index';
import { ICardDataProvider, ICard } from 'common/devices/card-reader';

@A9Service('mysticalCardOrderDataProvider')
export class MysticalCardOrderDataProvider extends AbstractDataProvider<ICard> implements ICardDataProvider {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/card-order');
    }
}
